import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, MessageCircle } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-background border-t py-8 mt-12">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Column 1: Logo and About */}
          <div>
            <div className="mb-6">
              <Logo isWhite={true} />
            </div>
            <p>
              Premium web design & full-stack development services from Nottingham to the world. British expertise delivering exceptional digital experiences.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="text-xl font-bold text-primary-light mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="hover:text-primary-light transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-primary-light transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-primary-light transition-colors">Services</Link></li>
              <li><Link to="/our-process" className="hover:text-primary-light transition-colors">Our Process</Link></li>
              <li><Link to="/why-choose-us" className="hover:text-primary-light transition-colors">Why Choose Us</Link></li>
              <li><Link to="/advice" className="hover:text-primary-light transition-colors">Articles</Link></li>
            </ul>
          </div>

          {/* Column 3: Our Services */}
          <div>
            <h4 className="text-xl font-bold text-primary-light mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services/web-design" className="hover:text-primary-light transition-colors">Web Design</Link></li>
              <li><Link to="/services/full-stack-development" className="hover:text-primary-light transition-colors">Full-Stack Development</Link></li>
              <li><Link to="/services/maintenance" className="hover:text-primary-light transition-colors">Monthly Maintenance</Link></li>
              <li><Link to="/services/technical-seo" className="hover:text-primary-light transition-colors">Technical SEO</Link></li>
              <li><Link to="/services/ecommerce" className="hover:text-primary-light transition-colors">E-commerce Solutions</Link></li>
              <li><Link to="/services/web-applications" className="hover:text-primary-light transition-colors">Web Applications</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div>
            <h4 className="text-xl font-bold text-primary-light mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Mail size={18} className="mr-3 mt-1 text-primary-light" />
                <a href="mailto:hello@consiliuma.co.uk" className="hover:text-primary-light transition-colors">
                  hello@consiliuma.co.uk
                </a>
              </li>
              <li className="flex items-start">
                <MessageCircle size={18} className="mr-3 mt-1 text-primary-light" />
                <a
                  href="https://t.me/ConsiliumaDesign"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-primary-light"
                >
                  Telegram: @ConsiliumaDesign
                </a>
              </li>
              <li className="flex items-start">
                <MapPin size={18} className="mr-3 mt-1 text-primary-light" />
                <div>
                  <p>Offices in:</p>
                  <p>Nottingham, UK</p>
                  <p>Arizona, USA</p>
                  <p>SE Asia</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700 w-full flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} Consiliuma. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-primary-light transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-conditions" className="text-sm text-gray-400 hover:text-primary-light transition-colors">
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;